import React from "react";
import { ShieldAlert } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const blockedInfo = (detail) => (detail && typeof detail === "object" && ["account_suspended", "account_deleted"].includes(detail.code) ? detail : null);

export default function AccountBlockedDialog({ info, onClose }) {
  if (!info) return null;
  const deleted = info.code === "account_deleted";
  const until = info.until === "permanent" ? "permanently" : info.until ? `until ${new Date(info.until).toLocaleString("en-GB", { dateStyle: "long", timeStyle: "short" })}` : "";
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#0d1117] border-red-500/30 text-white max-w-md z-[200]" data-testid="account-blocked-dialog">
        <DialogHeader>
          <span className="mx-auto w-14 h-14 rounded-2xl bg-red-500/15 grid place-items-center text-red-400"><ShieldAlert size={28} /></span>
          <DialogTitle className="text-center text-xl mt-3" data-testid="account-blocked-title">{deleted ? "Account deleted" : "Account suspended"}</DialogTitle>
          <DialogDescription className="text-center text-white/60">
            {deleted ? "This account was deleted for violating the 7 Legendary community rules and can no longer sign in or register."
              : `Your account has been suspended ${until} for violating the 7 Legendary community rules.`}
          </DialogDescription>
        </DialogHeader>
        {info.reason && <div className="rounded-xl bg-white/5 border border-white/10 p-3 text-sm" data-testid="account-blocked-reason"><span className="text-white/40 text-xs uppercase tracking-wider block mb-1">Reason</span>{info.reason}</div>}
        <p className="text-xs text-white/40 text-center">If you believe this is a mistake, contact us via the <a href="/contact" className="text-[hsl(var(--primary))] underline">Contact</a> page.</p>
        <button onClick={onClose} data-testid="account-blocked-close" className="w-full py-2.5 rounded-full bg-white/10 hover:bg-white/15 font-bold">Close</button>
      </DialogContent>
    </Dialog>
  );
}
